import {Component, HostBinding, Inject, Injector, OnInit, ViewEncapsulation} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {animationSlideInOut} from '../../../../util/animation/animation.slideInOut';
import {StringUtil} from '../../../../util/string.util';

@Component({
  selector: 'app-factor',
  standalone: false,
  templateUrl: './factor.component.html',
  styleUrl: './factor.component.scss',
  animations: [animationSlideInOut],
  encapsulation: ViewEncapsulation.None,
})
export class FactorComponent extends BaseComponent implements OnInit {
  @HostBinding('@slideInOut') animationState = 'open';
  protected readonly StringUtil = StringUtil;
  protected readonly parseInt = parseInt;

  constructor(injector: Injector, public dialogRef: DialogRef<string>, @Inject(DIALOG_DATA) public data: any) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  noAction() {
    this.animationState = 'closed';
    this.dialogRef.close();
  }

  getCountAndPriceOfServicePriceAdditive(orderServicePriceAdditives: any, attributeId: any) {
    let count = 0;
    let totalPrice = 0;
    orderServicePriceAdditives.forEach((orderServicePriceAdditive: any) => {
      if (orderServicePriceAdditive.ServicePriceAdditive.AttributeId === attributeId) {
        totalPrice += orderServicePriceAdditive.ServicePriceAdditive.NewPrice ? parseFloat(orderServicePriceAdditive.ServicePriceAdditive.NewPrice) : parseFloat(orderServicePriceAdditive.ServicePriceAdditive.Price);
        count++;
      }
    });
    return {
      TotalPrice: totalPrice,
      Count: count
    };
  }
}
